export default __webpack_public_path__ + "img/bwVkJvws.3231690d.svg";